import { ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative bg-[#09090B] border-t border-white/5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24 sm:py-32 lg:py-40 relative">
        {/* Ambient glow */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[#E5D0A1] opacity-[0.04] blur-[120px]" />
        </div>

        <div className="relative max-w-5xl">
          <p className="font-mono-small text-[#E5D0A1] mb-8">
            — Ready When You Are
          </p>
          <h2 className="font-display text-white text-5xl sm:text-7xl lg:text-[120px] tracking-[-0.04em] leading-[0.92]">
            Let&apos;s make it
            <br />
            <span className="font-editorial italic text-[#E5D0A1] font-normal">
              look new again.
            </span>
          </h2>

          <div className="mt-14 flex flex-col sm:flex-row gap-4 sm:gap-6">
            <a
              href="#quote"
              data-testid="final-cta-primary"
              className="group inline-flex items-center justify-center gap-3 bg-white text-black px-8 py-5 font-medium hover:bg-[#E5D0A1] transition-all duration-500"
            >
              Get a 30-Second Quote
              <ArrowUpRight
                className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                strokeWidth={1.5}
              />
            </a>
            <a
              href="tel:+14805550120"
              data-testid="final-cta-phone"
              className="inline-flex items-center justify-center gap-3 border border-white/20 text-white px-8 py-5 font-medium hover:bg-white/5 hover:border-white/40 transition-all duration-500"
            >
              (480) 555 — 0120
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
